import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, GetQuery } from './Shared';

interface UserList {
    id: number;
    name: string;
    company: string;
    department: string;
    extension: number;
    mobile: string;
    email: string;
    status: string;
}

const UserSearchData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [showInactive, setShowInactive] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [results, setResults] = useState<UserList[]>([]);
    
    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("CreateEditUsers");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied");
        }
    }

    const addNew = () => {
        navigate("/user/0")
    }

    const reset = () => {
        setName("");
        setEmail("");
        setShowInactive(false);
        setResults([]);
        setShowResults(false);
    }

    const search = (e: any) => {
        e.preventDefault();
        //check to make sure at least one search field has been entered
        if (name || email) {
            searchUsers();
        } else {
            setShowResults(false);
            toast.error("Please enter at least one search item");
        }
    }

    const searchUsers = async () => {
        const apiUrl = "SearchUsers?Name=" + name + "&Email=" + email + "&ShowInactive=" + showInactive;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setShowResults(true);
            setResults(result.data);
        };
    }

    const renderUserSearch = (
        <div>
            <div>
                <label className="input-group--inline" htmlFor="name">
                    <span className="label">Name</span>
                    <input className="input" type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)}></input>
                </label>
                <label className="input-group--inline" htmlFor="email">
                    <span className="label">Email</span>
                    <input className="input" type="text" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}></input>
                </label>
 
                <label className="input-group--inline" htmlFor="inactive">
                    <span className="label">Show Inactive</span>
                    <input className="input" type="checkbox" id="inactive" name="showInactive" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)}></input>
                </label>

                <button className="defaultbutton" type="button" onClick={search}>Search</button>
                <button className="defaultbutton marginLeft10" type='button' onClick={reset}>Reset</button>
            </div>
            <div className="row">
                <hr></hr>
            </div>
            <div className={showResults ? 'overflowAuto' : 'hidden'}>
                <table className='table tableColours'>
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Company</th>
                            <th>Extn.</th>
                            <th>Mobile</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map(user =>
                            <tr key={user.id}>
                                <td className="hidden">{user.id}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.company}</td>
                                <td>{user.extension}</td>
                                <td>{user.mobile}</td>
                                <td>{user.status}</td>
                                <td>
                                    <Link to={'/user/' + user.id}>
                                        Open
                                    </Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderUserSearch;

    return (
        <div>
            <div className="makeitflexspacebetween">
                <h1>User Search</h1>
                <button className="defaultbutton defaultbutton__small marginTop10" type='button' onClick={addNew}>Add New</button>
            </div>
            {contents}
        </div>
    )
}

export default UserSearchData;

